export interface IEnvironment {
  production: boolean;
  analytics: boolean;
  defaultPort: number;
  devOrigin?: string;
  buildOrigin: string;
  cmsOrigin: string;
  apiOrigin: string;
  signaturGruppen_BrokerOgirin: string;
  appInsights: {
    instrumentationKey: string;
  };
  i18n: {
    language: string;
    currency: string;
    country: string;
  };
  urls: {
    content: {
      trade_conditions: string;
      gdpr: string;
      cookie_policy: string;
      questions_and_answers: string;
      contact_us: string;
      newsletter_signup: string;
      merchant_content: string;
      customer_service: string;
    };
    products: string;
    gift_card: string;
    basket: string;
    orders: string;
    checkout: string;
    confirmation: string;
    kiosk: {
      confirmation: string;
      closed: string;
    };
    member_set_password: string;
    page_not_found: string;
  };
}

export const defaultEnvironment: IEnvironment = {
  production: false,
  analytics: false,
  defaultPort: 4201,
  buildOrigin: 'demosalg.catersys.dk',
  cmsOrigin: 'https://nxtumbraco.azurewebsites.net',
  apiOrigin: 'https://nxtecom.azurewebsites.net',
  signaturGruppen_BrokerOgirin: 'https://netseidbroker.dk',
  appInsights: {
    instrumentationKey: '045daa80-d3fc-4822-96ab-508a02388745',
  },
  i18n: {
    language: 'da-DK',
    currency: 'DKK',
    country: 'Danmark',
  },
  urls: {
    content: {
      trade_conditions: 'handelsbetingelser',
      gdpr: 'persondatapolitik',
      cookie_policy: 'cookiepolitik',
      questions_and_answers: 'spoergsmaal-og-svar',
      contact_us: 'kontakt-os',
      newsletter_signup: 'nyhedsbrev',
      merchant_content: 'artikler',
      customer_service: 'kundeservice',
    },
    products: 'produkter',
    gift_card: 'gavekort',
    basket: 'kurv',
    orders: 'ordre',
    checkout: 'checkout',
    confirmation: 'confirmation',
    kiosk: {
      confirmation: 'kioskconfirmation',
      closed: 'kioskclosed',
    },
    member_set_password: 'member-login',
    page_not_found: '404',
  },
};
